(function () {
  function initTabs(root) {
    var buttons = root.querySelectorAll('[data-hp-tab]');
    var panels = root.querySelectorAll('[data-hp-panel]');
    if (!buttons.length || !panels.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-hp-tab');
        buttons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-hp-panel') === id;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-hp-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-hp-tabs]');
    if (root) initTabs(root);
  });
})();
